import { Application } from '@hotwired/stimulus';
import ApexChartController from './controllers/apex-chart-controller';
import ApplicationController from './controllers/application-controller';
import CheckboxController from './controllers/checkbox-controller';
import PasswordController from './controllers/password-input-controller';
import ClassicSelectController from './controllers/classic-select-controller';
import DataTableController from './controllers/data-table-controller';
import DatePickerController from './controllers/date-picker-controller';
import DragAndDropController from './controllers/drag-and-drop-controller';
import FileInputController from './controllers/file-input-controller';
import FormController from './controllers/form-controller';
import HorizontalDragController from './controllers/horizontal-drag-controller';
import NavItemController from './controllers/nav-item-controller';
import RadioController from './controllers/radio-controller';
import RepeaterController from './controllers/repeater-controller';
import SelectController from './controllers/select-controller';
import TextAreaController from './controllers/textarea-controller';
import ToggleCheckboxController from './controllers/toggle-checkbox-controller';
import TriggersController from './controllers/triggers-controller';
import StickyScrollController from './controllers/sticky-scroll-controller';

if (!window.Stimulus) {
    window.Stimulus = Application.start();

    Stimulus.register('application', ApplicationController);
    Stimulus.register('nav-item', NavItemController);
    Stimulus.register('data-table', DataTableController);
    Stimulus.register('drag-and-drop', DragAndDropController);
    Stimulus.register('form', FormController);
    Stimulus.register('select', SelectController);
    Stimulus.register('classic-select', ClassicSelectController);
    Stimulus.register('repeater', RepeaterController);
    Stimulus.register('checkbox', CheckboxController);
    Stimulus.register('password', PasswordController);
    Stimulus.register('radio', RadioController);
    Stimulus.register('toggle-checkbox', ToggleCheckboxController);
    Stimulus.register('date-picker', DatePickerController);
    Stimulus.register('text-area', TextAreaController);
    Stimulus.register('file-input', FileInputController);
    Stimulus.register('horizontal-drag', HorizontalDragController);
    Stimulus.register('apex-chart', ApexChartController);
    Stimulus.register('triggers', TriggersController);
    Stimulus.register('sticky-scroll', StickyScrollController);
}
